var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "1200",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("FormHeader", {
                        attrs: {
                          loading: _vm.loading,
                          link: "page-attributes",
                          title: _vm.data.displayName
                            ? `${_vm.data.displayName} атрибут`
                            : `Создать атрибут`,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-select", {
                                    ref: "typeSelect",
                                    attrs: {
                                      label: "Тип *",
                                      id: "type",
                                      outlined: "",
                                      "item-value": "type",
                                      "item-text": "type",
                                      items: _vm.$options.attributeTypes,
                                      "error-messages":
                                        _vm.validationErrors.type,
                                      disabled: _vm.loading,
                                      value: _vm.fields.type,
                                    },
                                    on: {
                                      change: _vm.updateTypeHandler,
                                      input: function ($event) {
                                        return _vm.$v.fields.type.$touch()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v("Заголовок * ("),
                                      _c("TranslationIcon"),
                                      _vm._v(")"),
                                    ],
                                    1
                                  ),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      autofocus: "",
                                      id: "displayName",
                                      "error-messages":
                                        _vm.validationErrors.displayName,
                                      disabled: _vm.loading || !_vm.fields.type,
                                    },
                                    model: {
                                      value: _vm.fields.displayName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.fields, "displayName", $$v)
                                      },
                                      expression: "fields.displayName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      id: "name",
                                      label: "Имя *",
                                      disabled: _vm.loading || !_vm.fields.type,
                                      "error-messages":
                                        _vm.validationErrors.name,
                                    },
                                    model: {
                                      value: _vm.fields.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.fields, "name", $$v)
                                      },
                                      expression: "fields.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [_c("v-divider")],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c("v-col", { attrs: { cols: "auto" } }, [
                                _vm._v(" Правила валидации: "),
                              ]),
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        transition: "scroll-y-transition",
                                        "offset-y": "",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.loading ||
                                                          !_vm.fields.type ||
                                                          !_vm.attributeRules()
                                                            .length,
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "pr-1" },
                                                    [_vm._v(" mdi-plus ")]
                                                  ),
                                                  _c("span", [
                                                    _vm._v("Добавить"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        _vm._l(
                                          _vm.attributeRules(),
                                          function (item, itemIndex) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: itemIndex,
                                                attrs: {
                                                  disabled:
                                                    !!_vm.validationRule(item),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.fields.validationRules.push(
                                                      Object.assign({}, item)
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.title) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.fields.validationRules,
                            function (validationRule, validationRuleIndex) {
                              return _c(
                                "v-row",
                                { key: validationRuleIndex },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      attrs: { flat: "", color: "transparent" },
                                    },
                                    [
                                      _c(
                                        "v-card-title",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                "no-gutters": "",
                                                align: "center",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(validationRule.title) +
                                                  " "
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    disabled: _vm.loading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.fields.validationRules =
                                                        _vm.fields.validationRules.filter(
                                                          (i) =>
                                                            i.type !==
                                                            validationRule.type
                                                        )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { color: "red" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-trash-can-outline"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              validationRule.isValueFieldAvailable
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "auto" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            "Значение валидации",
                                                          outlined: "",
                                                          disabled: _vm.loading,
                                                        },
                                                        model: {
                                                          value:
                                                            validationRule.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              validationRule,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "validationRule.value",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "auto" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        "Сообщение валидации",
                                                      outlined: "",
                                                      disabled: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        validationRule.message,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          validationRule,
                                                          "message",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "validationRule.message",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c("ManageSidePanel", {
                attrs: {
                  isNew: _vm.isNew,
                  "created-at": _vm.data.createdAt,
                  "updated-at": _vm.data.updatedAt,
                  "published-at": _vm.data.publishedAt,
                  language: _vm.language,
                  translations: _vm.fields.translations,
                  "entity-id": _vm.data.id,
                  "entity-type": "attribute",
                },
                on: {
                  delete: function ($event) {
                    return _vm.$emit("delete-attr")
                  },
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-attributes" })
                  },
                  "update-translations": function ($event) {
                    return Object.assign(_vm.fields.translations, $event)
                  },
                  "language-update": function ($event) {
                    return _vm.$emit("language-update", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v("> "),
          _c("ConfirmationDialog", {
            ref: "confirmTypeChanging",
            attrs: {
              confirmText: "Подвтердить",
              description:
                "Изменение 'Типа' приведет к обнулению данных валидации",
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }